// SharePoint drives store their site list in the favorite's region key, in the
// format the desktop client writes and the exfs core reads: entries joined by "|",
// each entry "siteUrl^displayName". The core skips any entry without both parts and
// uses the display name as the folder name at the root of the mounted drive.
//
// The web console cannot list a tenant's sites (that needs the user's SharePoint
// sign-in, which only happens on the device), so admins enter each site as a row
// with its URL and an optional display name.
export const SHAREPOINT_SITE_URL_ERROR = 'Enter the site’s full https:// URL.'

const RESERVED = /[|^]/g

export const siteNameFromUrl = url => {
  try {
    const { hostname, pathname } = new URL(url)
    const lastSegment = pathname.split('/').filter(Boolean).pop()

    return decodeURIComponent(lastSegment || hostname)
  } catch {
    return url
  }
}

// The web form before MR !72 joined typed values with "," and never wrote "^", so a
// stored value with neither "|" nor "^" is that legacy format and splits on ",".
const isLegacyWebFormat = region => !region.includes('|') && !region.includes('^')

export const parseSharePointSites = region => {
  const stored = region || ''

  return stored
    .split(isLegacyWebFormat(stored) ? ',' : '|')
    .map(entry => entry.trim())
    .filter(Boolean)
    .map(entry => {
      const [url, ...nameParts] = entry.split('^')

      return { name: nameParts.join('^') || siteNameFromUrl(url), url }
    })
}

export const formatSharePointSites = sites => sites
  .map(({ name, url }) => `${url}^${(name || siteNameFromUrl(url)).replace(RESERVED, '')}`)
  .join('|')

// Rows for the form. The display name is left blank when it is just the default
// derived from the URL, so the admin sees only what they chose.
export const sharePointSiteRows = region => parseSharePointSites(region)
  .map(({ name, url }) => ({ name: name === siteNameFromUrl(url) ? '' : name, url }))

// Commas are rejected because the legacy web format used them as the list separator.
export const validateSharePointSiteUrl = url => (/^https:\/\/[^\s^|,]+$/i.test(url) ? null : SHAREPOINT_SITE_URL_ERROR)
